export default "__VITE_ASSET__Dd6JdZnm__"